import(/* webpackMode: "eager" */ "/home/runner/work/agentx/agentx/node_modules/.pnpm/next@15.0.3_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
